import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiCircularProgress = () =>
  ({
    MuiCircularProgress: {
      defaultProps: {
        size: spacing(2),
      },
    },
  }) satisfies ComponentCreation
